import { getErrorMessage } from './helpers';

const multiploErrors = {
  install (Vue, options) {
    Vue.prototype.$getErrorMessage = getErrorMessage;
  }
}

export default multiploErrors;
